import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image,
  StyleSheet,
  Font,
  PDFDownloadLink,
  Link as LinkPDF,
} from "@react-pdf/renderer";

import Folks from "../../../App/fonts/Folks-Normal.ttf";
import Folks_bold from "../../../App/fonts/Folks-Bold.ttf";
import Folks_heavy from "../../../App/fonts/Folks-Heavy.ttf";
import Arial_bold from "../../../App/fonts/arialbd.ttf";
import {
  Table,
  TableHeader,
  TableCell,
  TableBody,
  DataTableCell,
  TableRow,
} from "@david.kucsai/react-pdf-table";
import header_contrato from "../../../App/images/header_contrato_v2.jpeg"

function PoPdf({ dataOp }) {
  const calculateData = (d) => {
    const dataCopy = JSON.parse(JSON.stringify(d));

    if (dataCopy.discount){
      dataCopy.discount = parseFloat(dataCopy.discount)
    }
    if (dataCopy.retention){
      dataCopy.retention = parseFloat(dataCopy.retention)
    }
    if (dataCopy.iva){
      dataCopy.iva = parseFloat(dataCopy.iva)
    }

    const ParseFormattedNumber = (value) => {
      if (typeof value === "number") {
        return value;
      }
      if (typeof value !== "string") {
        return parseFloat(value) || 0;
      }
      return parseFloat(value.replace(/\./g, "").replace(",", ".")) || 0;
    };

    const itemsWithParsedPrices = dataCopy.items.map((item) => ({
      ...item,
      price: ParseFormattedNumber(item.price),
      quantity: ParseFormattedNumber(item.quantity),
      iva: ParseFormattedNumber(item.iva || 0)
    }));

    let total = 0;
    itemsWithParsedPrices.forEach((item, index) => {
      item.index = index;
      total += item.quantity * item.price;
    });

    const discountValue = total * (ParseFormattedNumber(dataCopy.discount) / 100);
    const subTotal = total - discountValue;
    const retentionValue = subTotal * (ParseFormattedNumber(dataCopy.retention) / 100);
    
    // Calcular IVA basado en el IVA de cada item si está disponible
    let ivaValue = 0;
    if (dataCopy.items && dataCopy.items.length > 0 && dataCopy.items[0].iva !== undefined) {
      // Si los items tienen IVA individual, calcular el total
      ivaValue = itemsWithParsedPrices.reduce((total, item) => {
        const itemIva = ParseFormattedNumber(item.iva || 0);
        const itemTotal = item.quantity * item.price;
        return total + (itemTotal * itemIva);
      }, 0);
    } else {
      // Si no hay IVA individual, usar el IVA general
      ivaValue = subTotal * (ParseFormattedNumber(dataCopy.iva) / 100);
    }
    
    const greatTotal = subTotal - retentionValue + ivaValue;

    return {
      ...dataCopy,
      items: itemsWithParsedPrices,
      total,
      discountValue,
      subTotal,
      retentionValue,
      ivaValue,
      greatTotal,
    };
  };

  const data = calculateData(dataOp);

  Font.register({ family: "Folks", src: Folks });
  Font.register({ family: "Folks_bold", src: Folks_bold });
  Font.register({ family: "Arial_bold", src: Arial_bold });
  Font.register({ family: "Folks_heavy", src: Folks_heavy });

  const styles = StyleSheet.create({
    bold: {
      fontFamily: "Folks_bold",
    },


    normal_txt: {
      fontFamily: "Folks",
    },



    page: {
      backgroundColor: "white",
      paddingBottom: 30,
    },


    subtabletxt: {
      fontSize: 13,
      paddingLeft: 2,
      fontFamily: "Folks",
    },

    tabletxt: {
      fontSize: 12,
      height: "40px",
      fontFamily: "Folks",
    },

    minitabletxt: {
      fontSize: 9,
      height: "40px",
      fontFamily: "Folks",
    },

    table: {
      marginTop: 25,
      marginBottom: 25,
    },


    position: {
      fontFamily: "Folks",
      color: "white",
      letterSpacing: 1,
      marginBottom: 5,
      fontSize: 15,
    },

    green: {
      color: "#006E42",
    },


    central_flex_row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between"
    },


    justify_central_flex: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },

    div_line: {
      marginTop: "15px",
      height: "3px",
      backgroundColor: "green",
      width: "100%",
    },

    pages_content: {
      padding: "0 25px"
    },

    title_cell: {
      backgroundColor: "#dbdbdb",
      height: "20px",
      textAlign: "center",
      fontSize: 12,
      fontFamily: "Folks_bold",
    },

    flex_view: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },

    obs_container: {
      border: "1pt solid #000000",
      minHeight: "90px",
      marginTop: "20px"
    }
  });

  const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    });
    return formatter.format(number);
  };

  return (
    <>
      <Document>
      <Page size={[816, 1056]} style={styles.page} wrap={true}>
        <View>
          <Image
            src={header_contrato}
            style={{ width: "816px", height: "192px" }}
          />
        </View>

        <View style={styles.pages_content}>
          <View style={styles.justify_central_flex}>
            <Text style={styles.bold}>CONTENEDORES DE ANTIOQUIA S.A.S.</Text>
            <Text style={styles.normal_txt}>NIT 900.167.316 – 4</Text>
            <Text style={styles.normal_txt}>Km 1 entrada a Girardota, Antioquia, Colombia</Text>
            <Text style={styles.normal_txt}>CONTENEDORES DE ANTIOQUIA S.A.S.</Text>
            <Text style={styles.normal_txt}>Cel: +57 {data.buyerPhone}</Text>
            <View style={{...styles.div_line, marginBottom: "10px"}}></View>
            <Text style={styles.bold}>ORDEN DE COMPRA</Text>
            <Text style={styles.normal_txt}>Purchase Order</Text>
          </View>
          <View style={[styles.central_flex_row, {paddingHorizontal: "30px"}]}>
            <View>
            <Text style={styles.normal_txt}>Fecha Pedido: {new Date().toISOString().split('T')[0]}</Text>
            <Text style={styles.normal_txt}>Comprador: {data.buyerName}</Text>
            </View>
            <View>
            <Text style={{...styles.normal_txt, ...styles.bold}}>OC: {data.poId}</Text>
            </View>
          </View>
          <View style={{marginTop: "20px"}}>
          <Table data={[{}]} >
              <TableHeader></TableHeader>
              <TableBody >
                <DataTableCell
                  getContent={(r) => "PROVEEDOR"}
                  weighting={0.2}
                  style={styles.title_cell}
                />
                <DataTableCell
                  getContent={(r) => data.supplierName}
                  weighting={0.4}
                  style={styles.subtabletxt}
                />
                <DataTableCell
                  getContent={(r) => "FORMA DE PAGO"}
                  weighting={0.2}
                  style={styles.title_cell}
                />
                <DataTableCell
                  getContent={(r) => data.paymentMethod}
                  weighting={0.2}
                  style={styles.subtabletxt}
                />


              </TableBody>
            </Table>
            <Table data={[{}]}>
              <TableBody >
                <DataTableCell
                  getContent={(r) => "NIT"}
                  weighting={0.2}
                  style={styles.title_cell}
                />
                <DataTableCell
                  getContent={(r) => data.governmentId}
                  weighting={0.4}
                  style={styles.subtabletxt}
                />
                <DataTableCell
                  getContent={(r) => "PLAZO"}
                  weighting={0.2}
                  style={styles.title_cell}
                />
                <DataTableCell
                  getContent={(r) => data.paymentTerm}
                  weighting={0.2}
                  style={styles.subtabletxt}
                />


              </TableBody>
            </Table>
            <Table data={[{}]}>
              <TableBody >
                <DataTableCell
                  getContent={(r) => "TELÉFONO"}
                  weighting={0.2}
                  style={styles.title_cell}
                />
                <DataTableCell
                  getContent={(r) => data.phone}
                  weighting={0.4}
                  style={styles.subtabletxt}
                />
                <DataTableCell
                  getContent={(r) => "AUTORETENEDOR"}
                  weighting={0.2}
                  style={styles.title_cell}
                />
                <DataTableCell
                  getContent={(r) => {if (data.autoRetainer) return "Si"; else return "No";}}
                  weighting={0.2}
                  style={styles.subtabletxt}
                />


              </TableBody>
            </Table>
            <Table data={[{}]}>
              <TableBody >
                <DataTableCell
                  getContent={(r) => "EMAIL"}
                  weighting={0.2}
                  style={styles.title_cell}
                />
                <DataTableCell
                  getContent={(r) => data.email}
                  weighting={0.8}
                  style={styles.subtabletxt}
                />
                
              </TableBody>
            </Table>
            <Table data={[{}]}>
              <TableBody >
                <DataTableCell
                  getContent={(r) => "DIRERCCIÓN"}
                  weighting={0.2}
                  style={styles.title_cell}
                />
                <DataTableCell
                  getContent={(r) => data.address}
                  weighting={0.8}
                  style={styles.subtabletxt}
                />
                
              </TableBody>
              
            </Table >
            <View style={{marginTop: "20px"}}>

            <Table data={data.items} >
              <TableHeader>
                <TableCell style={styles.title_cell} weighting={0.02}></TableCell>
                <TableCell style={styles.title_cell} weighting={0.12}>CÓDIGO</TableCell>
                <TableCell style={styles.title_cell} weighting={0.43}>DESCRIPCIÓN</TableCell>
                <TableCell style={styles.title_cell} weighting={0.06}>UNIDAD</TableCell>
                <TableCell style={styles.title_cell} weighting={0.05}>CANT</TableCell>
                <TableCell style={styles.title_cell} weighting={0.12}>VALOR</TableCell>
                <TableCell style={styles.title_cell} weighting={0.12}>TOTAL</TableCell>
                <TableCell style={styles.title_cell} weighting={0.06}>IVA</TableCell>
              </TableHeader>
              <TableBody textAlign="center">
              <DataTableCell
                  getContent={(r) => r.index +1 }
                  style={styles.tabletxt}
                  weighting={0.02}
                />
                <DataTableCell
                  getContent={(r) => r.product_code}
                  style={styles.tabletxt}
                  weighting={0.12}
                />
                <DataTableCell
                  getContent={(r) => r.extra_description? `**${r.description}**\n${r.extra_description}`: r.description}
                  style={styles.minitabletxt}
                  weighting={0.43}
                />
                <DataTableCell
                  getContent={(r) => r.unit}
                  style={styles.tabletxt}
                  weighting={0.06}
                />
                <DataTableCell
                  getContent={(r) => r.quantity}
                  style={styles.tabletxt}
                  weighting={0.05}
                />
                <DataTableCell
                  getContent={(r) => toCurrency(r.price)}
                  style={styles.tabletxt}
                  weighting={0.12}
                />
                  <DataTableCell
                    getContent={(r) => toCurrency(r.quantity * r.price)}
                    style={styles.tabletxt}
                    weighting={0.12}
                  />
                <DataTableCell
                  getContent={(r) => `${(r.iva * 100).toFixed(1)}%`}
                  style={styles.tabletxt}
                  weighting={0.06}
                />
                
              </TableBody>
            </Table>
            </View>
            <View wrap={false}>
              <View style={{...styles.flex_view, justifyContent: "space-between", marginTop: "20px"}}>
                <View style={{flex: 0.48}}>
                  <Table data={[{}]}>
                  <TableHeader>
                      <TableCell style={styles.title_cell}>
                        DIRECCIÓN DE ENTREGA
                      </TableCell>
                  </TableHeader>
                    <TableBody textAlign="center">
                      <DataTableCell
                        getContent={(r) => data.deliveryAdress}
                        style={styles.tabletxt}
                      />
                      
                    </TableBody>
                    
                  </Table>
                  <Table data={[{}]}>
                  <TableHeader>
                      <TableCell style={styles.title_cell}>
                        FECHA DE ENTREGA
                      </TableCell>
                  </TableHeader>
                  <TableBody textAlign="center">
                    <DataTableCell
                      getContent={(r) => data.deliveryDate}
                      style={styles.tabletxt}
                    />
                  </TableBody>  
                  </Table>
                  <Text style={{fontFamily: "Folks", fontSize: "14", marginTop: "20px"}}>Toda factura debe llevar el numero de la orden de compra asociado. <Text style={styles.bold}>OC {data.poId}</Text></Text>
                </View>
                <View style={{flex: 0.48}}>
                  <Table data={[0]}>
                    <TableHeader></TableHeader>
                    <TableBody >
                      <DataTableCell
                        getContent={(r) => "VALOR"}
                        weighting={0.3}
                        style={styles.title_cell}
                      />
                      <DataTableCell
                        getContent={(r) =>  toCurrency(data.total)}
                        weighting={0.7}
                        style={styles.subtabletxt}
                      />
                      
                    </TableBody>
                  </Table>
                  <Table data={[0]}>
                    <TableBody >
                      <DataTableCell
                        getContent={(r) => "DESCUENTO"}
                        weighting={0.3}
                        style={styles.title_cell}
                      />
                      <DataTableCell
                        getContent={(r) => toCurrency(data.discountValue)}
                        weighting={0.7}
                        style={styles.subtabletxt}
                      />
                    </TableBody>
                  </Table>
                  <Table data={[0]}>
                    <TableBody >
                      <DataTableCell
                        getContent={(r) => "SUBTOTAL"}
                        weighting={0.3}
                        style={styles.title_cell}
                      />
                      <DataTableCell
                        getContent={(r) => toCurrency(data.subTotal)}
                        weighting={0.7}
                        style={styles.subtabletxt}
                      />
                    </TableBody>
                  </Table>
                  <Table data={[0]}>
                    <TableBody >
                      <DataTableCell
                        getContent={(r) => "IVA"}
                        weighting={0.3}
                        style={styles.title_cell}
                      />
                      <DataTableCell
                        getContent={(r) => toCurrency(data.ivaValue)}
                        weighting={0.7}
                        style={styles.subtabletxt}
                      />
                    </TableBody>
                  </Table>
                  <Table data={[0]}>
                    <TableBody >
                      <DataTableCell
                        getContent={(r) => "RETENCIÓN"}
                        weighting={0.3}
                        style={styles.title_cell}
                      />
                      <DataTableCell
                        getContent={(r) => `${data.retention}%`}
                        weighting={0.2}
                        style={styles.subtabletxt}
                      />
                      <DataTableCell
                        getContent={(r) => toCurrency(data.retentionValue)}
                        weighting={0.5}
                        style={styles.subtabletxt}
                      />
                    </TableBody>
                  </Table>
                  <View style={{marginTop: "20px"}}>
                  <TableHeader></TableHeader>
                  <Table data={[0]}>
                    <TableBody >
                      <DataTableCell
                        getContent={(r) => "TOTAL"}
                        weighting={0.3}
                        style={styles.title_cell}
                      />
                      
                      <DataTableCell
                        getContent={(r) => toCurrency(data.greatTotal)}
                        weighting={0.7}
                        style={styles.subtabletxt}
                      />
                    </TableBody>
                  </Table>
                  </View>
                </View>
              </View>
              <View style={styles.obs_container}>
                <Text style={{fontFamily: "Folks", fontSize: "14", padding: "10px"}}><Text  style={{padding: "10px", ...styles.bold}}>OBSERVACIONES:</Text> {data.observations}</Text>

              </View>
            </View>
          </View>
        </View>
        
      </Page>
      </Document>
    </>
  );
}

function ViewPoPdf() {
  return (
    <div>
      <PDFDownloadLink document={<PoPdf />} fileName="somename.pdf">
        {({ blob, url, loading, error }) =>
          loading ? "Loading document..." : "Download now!"
        }
      </PDFDownloadLink>
    </div>
  );
}

export { PoPdf, ViewPoPdf };
